import React, { useState, useEffect } from 'react';
import './Notfallnummern.css';
import '../../styles/CiTable.css';
import { host_url } from '../../App'; // Import host_url
import BackArrow from '../../BackArrow'; // Importiere die BackArrow-Komponente

function Notfallnummern() {
  const [notfallnummern, setNotfallnummern] = useState([]);

  useEffect(() => {
    fetch(`${host_url}/notfallnummern`)
      .then((response) => response.json())
      .then((data) => setNotfallnummern(data))
      .catch((error) => console.error("Fehler:", error));
  }, []);

  return (
    <div>
      <main className="notfallnummern-page">
      <div className="page-header">
          <BackArrow to="/" />
          <h1>Wichtige Nummern</h1>
        </div>
        <p className="notfall-description">Hier findest du alle wichtigen Telefonnummern und den Portal-Support.</p>
        <div className="ci-table-wrapper">
        <table className="ci-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Bereich</th>
              <th>Nummer</th>
            </tr>
          </thead>
          <tbody>
            {notfallnummern.map((nummer) => (
              <tr key={nummer.Name}>
                <td>{nummer.Name}</td>
                <td>{nummer.Bereich}</td>
                <td>
                  <a href={`tel:${nummer.Nummer}`}>{nummer.Nummer}</a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
        <p>
          <a href="mailto:support@stormini-portal.de" className="support-link">Problem melden</a>
        </p>
      </main>
    </div>
  );
}

export default Notfallnummern;
